function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBRook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(0,0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z ",
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,35.5 L 33,35.5 L 33,35.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13,31.5 L 32,31.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,29.5 L 31,29.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,16.5 L 31,16.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 34,14",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBRook);
export default __webpack_public_path__ + "static/media/b_rook.fdc575582c2cbe2ec82093702945226f.svg";
export { ForwardRef as ReactComponent };